import { pagingSettings } from '../../../utils/GridPagingUtils';
import SessionOverviewPageActionTypes from '../actions/session-overview-page-action-types';

const initialState = {
  loading: false,
  event: null,
  session: null,
  cancelToken: null,
  canWrite: false,
  isConfirmDialogVisible: false,
  participants: [],
  participantsLoading: false,
  participantsKeyword: '',
  participantsSkip: pagingSettings.paging.skip,
  participantsTake: pagingSettings.paging.take,
  participantsTotal: 0,
  participantsSorting: null,
  isAddParticipantDialogVisible: false,
  addParticipantValidationResult: null,
  availableStudents: [],
  availableStudentsLoading: false,
  isRemoveParticipantDialogVisible: false,
  selectedParticipantId: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SessionOverviewPageActionTypes.LOAD_SESSION_OVERVIEW_PAGE_START:
      return {
        ...state,
        loading: true
      };
    case SessionOverviewPageActionTypes.LOAD_SESSION_OVERVIEW_PAGE_END:
      return {
        ...state,
        loading: false,
        event: action.payload?.event,
        session: action.payload?.session,
        canWrite: action.payload?.canWrite
      };
    case SessionOverviewPageActionTypes.TOGGLE_SESSION_OVERVIEW_CONFIRM_DIALOG:
      return {
        ...state,
        isConfirmDialogVisible: action.payload?.isVisible ?? false,
        confirmDialogErrorMessage: action.payload?.errorMessage
      };
    case SessionOverviewPageActionTypes.LOAD_SESSION_PARTICIPANTS_START:
      return {
        ...state,
        participantsLoading: true
      };
    case SessionOverviewPageActionTypes.LOAD_SESSION_PARTICIPANTS_END:
      return {
        ...state,
        participantsLoading: false,
        participants: action.payload?.participants ?? [],
        participantsTotal: action.payload?.total ?? 0,
        participantsSkip: action.payload?.skip ?? state.participantsSkip,
        participantsTake: action.payload?.take ?? state.participantsTake
      };
    case SessionOverviewPageActionTypes.SET_PARTICIPANTS_KEYWORD:
      return {
        ...state,
        participantsKeyword: action.payload?.keyword ?? '',
        participantsSkip: initialState.participantsSkip
      };
    case SessionOverviewPageActionTypes.SORT_PARTICIPANTS:
      return {
        ...state,
        participantsSorting: action.payload?.sorting,
        participantsSkip: initialState.participantsSkip
      };
    case SessionOverviewPageActionTypes.TOGGLE_ADD_PARTICIPANT_DIALOG:
      return {
        ...state,
        isAddParticipantDialogVisible: action.payload?.isVisible ?? false,
        addParticipantValidationResult: null
      };
    case SessionOverviewPageActionTypes.ADD_PARTICIPANT_END:
      return {
        ...state,
        addParticipantValidationResult: action.payload?.validationResult ?? null
      };
    case SessionOverviewPageActionTypes.TOGGLE_REMOVE_PARTICIPANT_DIALOG:
      return {
        ...state,
        isRemoveParticipantDialogVisible: !!action.payload?.participantId,
        selectedParticipantId: action.payload?.participantId ?? null
      };
    case SessionOverviewPageActionTypes.LOAD_AVAILABLE_STUDENTS_START:
      return {
        ...state,
        availableStudentsLoading: true
      };
    case SessionOverviewPageActionTypes.LOAD_AVAILABLE_STUDENTS_END:
      return {
        ...state,
        availableStudentsLoading: false,
        availableStudents: action.payload?.students ?? []
      };
    case SessionOverviewPageActionTypes.CLEANUP_SESSION_OVERVIEW:
      return initialState;
    default:
      return state;
  }
};
